import React from 'react';
export var VerifyIcon = function () { return (React.createElement("svg", { viewBox: "0 0 16 16" },
    React.createElement("path", { fill: "none", d: "M0 0h16v16H0z" }),
    React.createElement("path", { fill: "#54b948", d: "M15 5.48L12.519 3 7.496 8.024 4.481 5.009 2 7.49l5.493 5.493.003-.003.003.003z" }),
    React.createElement("path", { fill: "#54b948", d: "M1 2h13V1H0v14h14V9h-1v5H1z" }))); };
//# sourceMappingURL=VerifyIcon.js.map